var map = {
	"./bg/LC_MESSAGES/django.po": 1179,
	"./cs/LC_MESSAGES/django.po": 1180,
	"./de/LC_MESSAGES/django.po": 1181,
	"./en/LC_MESSAGES/django.po": 678,
	"./es/LC_MESSAGES/django.po": 1182,
	"./fi/LC_MESSAGES/django.po": 1183,
	"./fr/LC_MESSAGES/django.po": 1184,
	"./it/LC_MESSAGES/django.po": 1185,
	"./ja/LC_MESSAGES/django.po": 1186,
	"./ru/LC_MESSAGES/django.po": 1187,
	"./zh_CN/LC_MESSAGES/django.po": 1188,
	"./zh_TW/LC_MESSAGES/django.po": 1189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1178;